export default __webpack_public_path__ + "static/media/union.c58f600c.svg";